// --- Gift Card: lowest in-stock variant (SLP + autocomplete) ---
var GIFT_CARD_HANDLES = ['physical-gift-card', 'digital-gift-card'];
var GIFT_GROUP_IDS = ['7970245869755', '8506747322555'];
var giftCardLowestVariantCache = {};

function isGiftCardProduct(product) {
  if (GIFT_GROUP_IDS.indexOf(String(product.groupId)) !== -1) return true;
  var attrs = product.attributes || [];
  for (var i = 0; i < attrs.length; i++) {
    if (attrs[i].name !== 'Handle') continue;
    var vals = attrs[i].values || [];
    for (var j = 0; j < vals.length; j++) {
      var handle = vals[j].value && vals[j].value[0];
      if (GIFT_CARD_HANDLES.indexOf(handle) !== -1) return true;
    }
  }
  return false;
}

function getLowestPriceVariant(product) {
  var attrs = product.attributes || [];
  var variantPrices = null;
  for (var i = 0; i < attrs.length; i++) {
    if (attrs[i].id === 'product_variant_prices' || attrs[i].name === 'Variant Prices') {
      variantPrices = attrs[i];
      break;
    }
  }
  if (!variantPrices || !variantPrices.values) return null;

  var lowest = null;
  for (var k = 0; k < variantPrices.values.length; k++) {
    var v = variantPrices.values[k];
    if (v.inStock === false || !v.variationId) continue;
    var price = Number(v.value && v.value[0]);
    if (!price || isNaN(price)) continue;
    if (!lowest || price < lowest.price) {
      lowest = { variationId: v.variationId, price: price };
    }
  }
  return lowest;
}

function setGiftCardSelectedVariant(product, lowest) {
  product.id = lowest.variationId;
  product.sellingPrice = lowest.price;
  product.finalPrice = lowest.price;
  product.price = lowest.price;
  product.newSellingPrice = lowest.price;
  if (product.url) {
    product.url = product.url.split('?')[0] + '?variant=' + lowest.variationId;
  }
}

function applyGiftCardLowestVariant(product) {
  if (!isGiftCardProduct(product)) return;

  var lowest = getLowestPriceVariant(product);
  if (!lowest && product.groupId) {
    lowest = giftCardLowestVariantCache[String(product.groupId)];
  }
  if (!lowest) return;

  if (product.groupId) {
    giftCardLowestVariantCache[String(product.groupId)] = lowest;
  }
  setGiftCardSelectedVariant(product, lowest);
}

function getAutocompleteProductLists(data) {
  if (!data) return [];
  var lists = [];

  if (Array.isArray(data)) lists.push(data);
  if (Array.isArray(data.products)) lists.push(data.products);
  if (data.products && Array.isArray(data.products.result)) lists.push(data.products.result);
  if (Array.isArray(data.result)) lists.push(data.result);
  if (data.payload && Array.isArray(data.payload.result)) lists.push(data.payload.result);
  var resp = data.response;
  var payload = resp && resp.payload;
  if (payload) {
    if (Array.isArray(payload.result)) lists.push(payload.result);
    if (payload.products && Array.isArray(payload.products.result)) lists.push(payload.products.result);
  }
  if (resp && Array.isArray(resp.result)) lists.push(resp.result);

  return lists;
}

function forEachAutocompleteProducts(data, fn) {
  var lists = getAutocompleteProductLists(data);
  for (var i = 0; i < lists.length; i++) {
    if (lists[i].length) {
      lists[i].forEach(fn);
      return true;
    }
  }
  return false;
}

function applyGiftCardAutocompleteData(data) {
  forEachAutocompleteProducts(data, function (product) {
    applyGiftCardLowestVariant(product);
  });
  return data;
}

// Header autocomplete uses search.js (direct fetch) — patch API response before render
(function () {
  if (!window.fetch) return;
  var originalFetch = window.fetch;

  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    return originalFetch.apply(this, arguments).then(function (response) {
      if (url.indexOf('api.wizzy.ai/v1/autocomplete') === -1) {
        return response;
      }

      return response.clone().json().then(function (data) {
        var products = data &&
          data.payload &&
          data.payload.products &&
          data.payload.products.result;
        if (products && products.length) {
          products.forEach(function (product) {
            applyGiftCardLowestVariant(product);
          });
        }
        return new Response(JSON.stringify(data), {
          status: response.status,
          statusText: response.statusText,
          headers: response.headers
        });
      }).catch(function () {
        return response;
      });
    });
  };
})();
// --- end Gift Card lowest variant ---

window.onWizzyScriptLoaded = function () {

  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
      function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      //     {
      //         "dom": "wizzy-search-input",
      //         "type": "text"
      //     }
      // ]
      // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

      return payload;
      }
  );

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
  function (payload) {
    window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
  //   window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
  //     {
  //         "dom": "wizzy-search-input",
  //         "type": "text"
  //     }
  //   ]
  //   window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  function (payload) {
    // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")
    
    
    payload.forEach(product => {
      if (product.attributes && Array.isArray(product.attributes)) {
        product.attributes.forEach(attr => {

          // -----------------------------------
          // Collection Page Tag
          // -----------------------------------
          if (attr.id === "product_collection_page_tag_custom" && attr.values?.length) {
            product.collectionPageTag =
            attr.values[0]?.value?.[0] || "";
          }

          // -----------------------------------
          // Bestseller Flag
          // -----------------------------------
          if (attr.id === "product_value_tags_is_bestseller_ruled_based_sy" && attr.values?.length ) {
            const bestsellerValue = attr.values[0]?.value?.[0]?.toLowerCase() || "";
            product.isBestseller = bestsellerValue === "yes";
          }

          // -----------------------------------
          // Judge.me Reviews
          // -----------------------------------
          if (attr.id === "product_badge_judgeme" && attr.values?.length) {

            const htmlString = attr.values[0]?.value?.[0] || "";

            // Extract average rating
            const ratingMatch = htmlString.match(
              /data-average-rating=['"]([^'"]+)['"]/
            );

            // Extract total reviews
            const reviewsMatch = htmlString.match(
              /data-number-of-reviews=['"]([^'"]+)['"]/
            );

            // Add on product level
            product.averageRating = ratingMatch
              ? parseFloat(ratingMatch[1])
              : 0;

            product.totalReviews = reviewsMatch
              ? parseInt(reviewsMatch[1], 10)
              : 0;

            product.isReviewAPresent = (product.totalReviews > 0);
          }

        });
      }
    });

    // --- Gift Card: lowest variant for search results ---
    payload.forEach(function (product) {
      applyGiftCardLowestVariant(product);
    });
    // --- end Gift Card lowest variant ---

    payload.forEach(product => {
      ['sellingPrice', 'price', 'discount'].forEach(key => {
        if (product[key] && typeof product[key] === 'string') {
          product[key] = product[key].replace(/\.00$/, '');
        }
      });
    });

    payload.forEach(product => {
      product.imageGroup = (product.images || []).slice(0, 3);
    });

    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
  function (payload) {
    // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
    // payload.minQueryLength = 1;
    return payload;
  }
);

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
    function (data) {
      applyGiftCardAutocompleteData(data);
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
      return payload;
    }
  );

 window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
  function (payload) {
    // console.log(payload,"BEFORE_SEARCH_EXECUTED")

    const overlaySearch = document.querySelector('.PageOverlay.is-visible');
    if (overlaySearch) {
      overlaySearch.click();
    }

    return payload;
  }
);

   window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  function (payload) {
    // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");      
    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
  function (data) {
    // console.log(data," <= VIEW_RENDERED");
    
    return data;
  }
);

 window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
  function (payload) {
    // console.log(payload,"BEFORE_RENDER_RESULTS");
  
    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
  function (payload) {
    return payload;
  }
);
};


///////////////////////////////////////////////////////////////


const body = document.body;
const wrapper = document.querySelector('.wizzy-body-end-wrapper');

function updateBodyClass() {
const autocomplete = wrapper?.querySelector('.wizzy-autocomplete-wrapper');

if (
  autocomplete &&
  getComputedStyle(autocomplete).display === 'flex'
) {
  body.classList.add('wizzy-autocomplete-open');
} else {
  body.classList.remove('wizzy-autocomplete-open');
}
}

// Observe DOM changes inside wrapper
const observer = new MutationObserver(() => {
updateBodyClass();
});

// Start observing
if (wrapper) {
observer.observe(wrapper, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['style', 'class']
});
}

// Run once on load
updateBodyClass();